/* eslint-disable no-underscore-dangle, no-param-reassign */
import Swiper from 'swiper';
import {
  Navigation,
  Pagination,
} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

/**
 * get bool value of attribute data-<name>
 */
function readBool(el, name, fallback = false) {
  const v = el.dataset[name];
  if (v == null) return fallback;
  return v === '' ? true : v === 'true' || v === '1';
}

/**
 * get number value of attribute data-<name>
 */
function readNum(el, name, fallback) {
  const v = el.dataset[name];
  if (v == null) return fallback;
  const n = Number(v);
  return Number.isFinite(n) ? n : fallback;
}

const defaultPaginationClass = '.swiper-pagination';
const defaultPrevClass = '.swiper-button-prev';
const defaultNextClass = '.swiper-button-next';

/**
 * return swiper pagination config
 * if DOM element exists or data-pagination attribute is set
 */
function getPaginationConfig(container, paginationClass = defaultPaginationClass) {
  const paginationEl = container.querySelector(paginationClass) || null;
  const enabled = readBool(container, 'pagination', !!paginationEl);

  return {
    enabled,
    el: paginationEl,
    config: enabled ? {
      el: paginationEl,
      clickable: true,
    } : false,
  };
}

/**
 * return swiper navigation config
 * if DOM elements exists or data-navigation attribute is set
 */
function getNavigationConfig(
  container,
  nextClass = defaultNextClass,
  prevClass = defaultPrevClass,
) {
  const nextEl = container.querySelector(nextClass) || null;
  const prevEl = container.querySelector(prevClass) || null;
  const enabled = readBool(container, 'navigation', !!nextEl || !!prevEl);

  return {
    enabled,
    nextEl,
    prevEl,
    config: enabled ? {
      nextEl,
      prevEl,
    } : false,
  };
}

/**
 * return swiper modules if previous configs enabled them
 */
function getModules(nav, pag) {
  const modules = [];
  if (nav.enabled) modules.push(Navigation);
  if (pag.enabled) modules.push(Pagination);

  return modules;
}

/**
 * general init function
 */
export function initSwipers(root = document) {
  const customerQuotes = root.querySelectorAll('.quote-slider');
  customerQuotes.forEach((container) => {
    if (container.__swiperInitialized) return; // guard against double init

    const autoheight = readBool(container, 'swiperAutoheight');
    const loop = readBool(container, 'loop');

    const nav = getNavigationConfig(
      container,
      '.quote-slider-next',
      '.quote-slider-prev'
    );
    const pag = getPaginationConfig(
      container,
      '.quote-slider-pagination'
    );
    const modules = getModules(nav, pag);

    const swiper = new Swiper(container, {
      modules,
      slidesPerView: 1,
      autoHeight: autoheight,
      loop: loop,
      pagination: pag.config,
      navigation: nav.config,
    });
    container.__swiper = swiper;
  });
}

// auto-init on DOM ready
if (document.readyState === 'loading') {
  window.addEventListener('load', () => initSwipers(), false);
} else {
  initSwipers();
}
